import { render, staticRenderFns } from "./UserConfirmPhoneNumberView.vue?vue&type=template&id=1d51c9bc&scoped=true&"
import script from "./UserConfirmPhoneNumberView.vue?vue&type=script&lang=js&"
export * from "./UserConfirmPhoneNumberView.vue?vue&type=script&lang=js&"
import style0 from "./UserConfirmPhoneNumberView.vue?vue&type=style&index=0&id=1d51c9bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d51c9bc",
  null
  
)

export default component.exports